exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".long-text-editor {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/field/long-text/long-text.component.scss
// module id = ../../../../../src/app/thought-module/field/long-text/long-text.component.scss
// module chunks = main